import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Button, CardActionArea, CardActions } from '@mui/material';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import courseImg from "../../assets/images/Digital-Marketing.jpg";
import webimg6 from "../../assets/images/webimg6.jpg";
import webimg2 from "../../assets/images/webimg2.jpg";
import { Link, useHistory } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import {
  Col,
  Row,
  CardBody,
  CardTitle,
} from "reactstrap";
import Marquee from "react-fast-marquee";
import "../../helpers/helper";


function TabPanel(props) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


export default function ZoomCourses(props) {

  const [value, setValue] = React.useState(0)
  const [invoices, setInvoice] = useState(null);
  useEffect(() => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${global.config.Token}`;

    const getData = async () => {
      const invoices = await axios.get(global.config.URL.api.lms + 'my-courses');
      console.log(invoices,'invoices')
      setInvoice(invoices.data.invoices);
    }
    getData();

  },[]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigateToZoom = (courseId) => {

    props.history.push({
      pathname: '/zoom-sessions',
      state: {
        course: courseId,
      }
    })
  }
  return (
    <React.Fragment>
      <div className="page-content">

        <Breadcrumbs title="Dashboard" breadcrumbItem="Select Course To Get Zoom Session" />
        <Row>
          <Col lg={12}>
            <Card className="">
              <CardBody>
                <Marquee direction="left" speed={30}>
                  <CardTitle className="welcome">Click on the given below tab to join Live Zoom Class and after 2 or 3 days You will get Live Zoom Class Recording here in the Play Video button &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</CardTitle>
                </Marquee>
              </CardBody>
            </Card>
          </Col>
          </Row>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              {
                invoices ? invoices.map((batch, i) => (
                  <Tab label={"Batch " + batch.batch.number} {...a11yProps(i)} />
                ))
                  :
                  ""
              }
            </Tabs>
          </Box>
        {
            invoices ? invoices.map((batch1, i) => (
              <TabPanel value={value} index={i}>
              <div style={{ position: 'relative' }}>
                {/* Display courses with fade effect if batch is inactive */}
                <Row style={{ opacity: batch1.batch.is_active ? 1 : 0.5 }}>
                  {batch1.courses.map((course, i) => (
                    <Col md={4} sm={6} className="mt-3" key={i}>
                      <Card
                        sx={{ maxWidth: 345 }}
                        onClick={() => batch1.batch.is_active && navigateToZoom(course.id)}
                      >
                        <CardActionArea>
                          <CardMedia
                            component="img"
                            height="140"
                            image={global.config.URL.img.public + course.course.course_detail.img}
                            alt={course.course.name}
                          />
                          <CardContent>
                            <Typography gutterBottom variant="h6" className="heading" component="div">
                              {course.course.name}
                            </Typography>
                            <Typography variant="body2" className="desc" align="justify" color="text.secondary">
                              {course.course.description}
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                        <CardActions>
                          <Button
                            size="small"
                            onClick={() => navigateToZoom(course.id)}
                            className="btnn"
                            disabled={!batch1.batch.is_active}
                          >
                            <i className="fa fa-check"></i> &nbsp; Get Sessions
                          </Button>
                        </CardActions>
                      </Card>
                    </Col>
                  ))}
                </Row>
            
                {/* Display message on top if batch is inactive */}
                {!batch1.batch.is_active && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)', /* translucent background */
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                      zIndex: 10, /* Ensure message appears on top */
                    }}
                  >
                    <div>
                    <strong>
                          <p>
                            We are pleased to announce that your journey with
                            PFTP has come to an end. We wish you very best of
                            luck for your future.
                          </p>
                          <p>
                            <b>NOTE</b> : From now onwards, you will not be able
                            to access any previous lectures/ recorded videos.
                            For FAQs, please visit our site:{" "}
                            <a href="https://pftpedu.org/">www.pftpedu.org </a>
                             For any information, you can contact/ whatsapp our
                            official numbers. Thank you
                          </p>
                          <p>Thanks</p>
                          <p>
                            Regards
                            <br />
                            PFTP Management
                          </p>
                        </strong>
                    </div>
                  </div>
                )}
              </div>
            </TabPanel>
            
            ))
              :
              <Row>
                <Col md={4} sm={6} className="mt-3">
                  <Stack spacing={1}>
                    <Skeleton animation="wave"  variant="rectangular" width={'100%'} height={140} />
                    <Skeleton width="60%" />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" height={20} sx={{ fontSize: '1rem' }} />

                  </Stack>
                </Col>
                <Col md={4} sm={6} className="mt-3">
                  <Stack spacing={1}>
                    <Skeleton animation="wave"  variant="rectangular" width={'100%'} height={140} />
                    <Skeleton width="60%" />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" height={20} sx={{ fontSize: '1rem' }} />

                  </Stack>
                </Col>
                <Col md={4} sm={6} className="mt-3">
                  <Stack spacing={1}>
                    <Skeleton animation="wave"  variant="rectangular" width={'100%'} height={140} />
                    <Skeleton width="60%" />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" height={20} sx={{ fontSize: '1rem' }} />

                  </Stack>
                </Col>
              </Row>
          } 
        </Box>
      </div>
    </React.Fragment>
  );
}